"use client";

import { Route } from "@faire/web-api/Route";
import { props as productBasedCollectionRouteProps } from "@faire/web-api/routes/product-based-collection/product_based_collection_token";
import React from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductBasedCollection } from "@faire/retailer/views/product-based-collection/__internal__/ProductBasedCollection";

export const RenderProductBasedCollectionRoute = () => {
  return (
    <Route
      {...productBasedCollectionRouteProps}
      exact
      render={({ match }) => {
        if (!match.params.productBasedCollectionToken) {
          throw new Error("Missing productBasedCollectionToken");
        }

        return (
          <ProductBasedCollection
            key={match.params.productBasedCollectionToken}
            token={match.params.productBasedCollectionToken}
          />
        );
      }}
    />
  );
};
